import pkg from '../package.json';
import {SL_construyeModulo} from './scribblelive.js';
import {
  DEFAULTS,
  CONFIG_NAMESPACE,
  DEFAULT_TEMPLATE,
  DEFAULT_AD_INDEX,
} from './constants.js';

import WidgetTemplate from './templates/widget.html';
import ContentTemplate from './templates/content.html';

const {$} = Voonto;

Voonto.ready.then((app) => {
  _init(app);
  app.on('voonto:reload', (event, context$) => _init(app, context$));
});

export const VERSION = pkg.version;

/* Private */

function _init(app, context$) {
  $('[data-voc-scribblelive]', context$).each(function () {
    var container$, id, options = {}, template, site, editions, hits, url, page;

    container$ = $(this);
    id = container$.attr('id') || `sl-${window.performance ? window.performance.now() : Date.now()}`;
    container$.attr('id', id);

    template = WidgetTemplate;
    if (container$.data('voc-scribblelive-template')) {
      template = ContentTemplate;
    }

    hits = DEFAULTS.SL_valor_numeroMensajesPagina;
    if ($(container$).data('voc-scribblelive-hits')) {
      hits = $(container$).data('voc-scribblelive-hits');
    }

    page = 'last';
    if ($(container$).data('voc-scribblelive-page')) {
      page = $(container$).data('voc-scribblelive-page');
    }

    url = DEFAULTS.SL_valor_evento1URLPaginaDetalle;
    if ($(container$).data('voc-scribblelive-url')) {
      url = $(container$).data('voc-scribblelive-url');
    }

    site = app.lookup('vocento.site');
    editions = app.lookup('vocento.site.editions');

    $.extend(options, DEFAULTS, {
      medio: site.media,
      edicion: editions.current,
      Scribble_pageElementId: id,
      SL_valor_evento1ID: container$.data('voc-scribblelive'),
      Scribble_template: template,
      SL_valor_numeroMensajesPagina: hits,
      SL_valor_evento1URLPaginaDetalle: url,
      PageNumber: page,
      container$
    });
    container$.empty();
    SL_construyeModulo(options);
  });
}



// WEBPACK FOOTER //
// ./src/index.js